import * as React from "react";
const SvgFiBrandsCreativeCommonsNcJp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-nc-jp_svg__a)">
      <path
        fill="#151A2D"
        d="M20.515 3.48Q17.031 0 11.984 0 6.999 0 3.545 3.48 0 7.08 0 12t3.545 8.46T11.984 24q4.957 0 8.591-3.57Q24 17.04 24 12t-3.485-8.52m-1.502 15.39q-2.974 2.94-6.998 2.94-4.026 0-6.939-2.91T2.163 12a9.7 9.7 0 0 1 .436-2.916l6.144 2.736H7.391v1.868h2.811l.275.57v.905H7.391v1.867h3.086v2.713h2.986V17.03h3.105v-1.726l3.918 1.745a9.3 9.3 0 0 1-1.473 1.821m-2.762-3.707h-2.787v-.905l.141-.273zm.318-2.485v-.859h-1.867l3.047-5.613h-3.184l-2.098 4.646-1.113-.496-1.917-4.15H6.251l1.321 2.467-3.961-1.765A11 11 0 0 1 5.106 5.04q2.824-2.88 6.909-2.88 4.084 0 6.938 2.88 2.883 2.85 2.883 6.96 0 1.522-.383 2.853z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-nc-jp_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsNcJp;
